// getters.js

export default {
    getNodeTreeList(state){
        return state.treeList?.sort((a, b) => {
            if (!a.created_at || !b.created_at) return 0;
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA; // Сортировка от новой к старой
        }) || [];
    }
};
